/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedResponse_PerformanceMapResponse_ } from '../models/PaginatedResponse_PerformanceMapResponse_';
import type { PerformanceMapCreateRequest } from '../models/PerformanceMapCreateRequest';
import type { PerformanceMapResponse } from '../models/PerformanceMapResponse';
import type { PerformanceMapSortRequest } from '../models/PerformanceMapSortRequest';
import type { PerformanceMapUpdateRequest } from '../models/PerformanceMapUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PerformanceMapService {
    /**
     * Create Performance Map
     * 성과 연결 생성
     *
     * 성과 분류와 대상을 연결합니다.
     * @returns PerformanceMapResponse Created
     * @throws ApiError
     */
    public static appsPerformanceViewsCreatePerformanceMap({
        requestBody,
    }: {
        requestBody: PerformanceMapCreateRequest,
    }): CancelablePromise<PerformanceMapResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/performance/map',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Performance Maps
     * 성과 연결 목록 조회 및 검색
     *
     * 성과 연결을 페이징하여 조회합니다. 검색 키워드가 제공되면 검색을 수행합니다.
     *
     * Args:
     * performance_category_id: 성과 분류 ID로 필터링 (선택사항)
     * link_type: 연결 타입으로 필터링 (선택사항)
     * target_id: 대상 ID로 필터링 (선택사항)
     * q: 검색 키워드 (선택사항) - 분류명, 연결타입, 대상ID로 검색
     * @returns PaginatedResponse_PerformanceMapResponse_ OK
     * @throws ApiError
     */
    public static appsPerformanceViewsListPerformanceMaps({
        performanceCategoryId,
        linkType,
        targetId,
        q,
        page = 1,
        perPage = 100,
    }: {
        performanceCategoryId?: string,
        linkType?: string,
        targetId?: string,
        q?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_PerformanceMapResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/performance/map',
            query: {
                'performance_category_id': performanceCategoryId,
                'link_type': linkType,
                'target_id': targetId,
                'q': q,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Performance Map
     * 성과 연결 조회
     *
     * ID로 특정 성과 연결을 조회합니다.
     * @returns PerformanceMapResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsGetPerformanceMap({
        mapId,
    }: {
        mapId: number,
    }): CancelablePromise<PerformanceMapResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/performance/map/{map_id}',
            path: {
                'map_id': mapId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Performance Map
     * 성과 연결 정보 수정
     *
     * 특정 성과 연결의 정보를 수정합니다.
     * @returns PerformanceMapResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsUpdatePerformanceMap({
        mapId,
        requestBody,
    }: {
        mapId: number,
        requestBody: PerformanceMapUpdateRequest,
    }): CancelablePromise<PerformanceMapResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/performance/map/{map_id}',
            path: {
                'map_id': mapId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Performance Map
     * 성과 연결 삭제
     *
     * 특정 성과 연결을 삭제합니다.
     * @returns void
     * @throws ApiError
     */
    public static appsPerformanceViewsDeletePerformanceMap({
        mapId,
    }: {
        mapId: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/performance/map/{map_id}',
            path: {
                'map_id': mapId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Performance Map Sort
     * 성과 연결 정렬 순서 변경
     *
     * 성과 연결의 정렬 순서를 변경합니다.
     * prev_map_id: 이동할 위치의 이전 성과연결 ID (맨 앞이면 None)
     * next_map_id: 이동할 위치의 다음 성과연결 ID (맨 뒤면 None)
     * @returns PerformanceMapResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsUpdatePerformanceMapSort({
        mapId,
        requestBody,
    }: {
        mapId: number,
        requestBody: PerformanceMapSortRequest,
    }): CancelablePromise<PerformanceMapResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/performance/map/{map_id}/sort',
            path: {
                'map_id': mapId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
